import CryptoJS from "crypto-js";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const formatted =
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0");
  return formatted;
};

export const formatDate2 = (dateString) => {
  const dayName = getDayFromDate(dateString);
  const monthName = getMonthNameFromDate(dateString);
  const dStartDate = new Date(dateString);
  const day = String(dStartDate.getDate()).padStart(2, "0");
  const year = String(dStartDate.getFullYear());

  const d = `${monthName} ${day}, ${year}`;
  return d;
};

export const getMonthNameFromDate = (dateString) => {
  const months = [
    "January (ජනවාරි)",
    "February (පෙබරවාරි)",
    "March (මාර්තු)",
    "April (අප්රේල්)",
    "May (මැයි)",
    "June (ජූනි)",
    "July (ජූලි)",
    "August (අගෝස්තු)",
    "September (සැප්තැම්බර්)",
    "October (ඔක්තෝබර්)",
    "November (නොවැම්බර්)",
    "December (දෙසැම්බර්)",
  ];
  const date = new Date(dateString);
  return months[date.getMonth()];
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  const formatted =
    date.getFullYear() +
    "-" +
    String(date.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(date.getDate()).padStart(2, "0") +
    " " +
    String(date.getHours()).padStart(2, "0") +
    ":" +
    String(date.getMinutes()).padStart(2, "0");
  return formatted;
};

export const formatTime = (time) => {
  const result = time.slice(0, 5);
  return result;
};

export const getDayFromDate = (dateString) => {
  const date = new Date(dateString);
  var day = date.getDay();

  if (day === 1) {
    return "Monday (සඳුදා)";
  } else if (day === 2) {
    return "Tuesday (අඟහරුවාදා)";
  } else if (day === 3) {
    return "Wednesday (බදාදා)";
  } else if (day === 4) {
    return "Thursday (බ්‍රහස්පතින්දා)";
  } else if (day === 5) {
    return "Friday (සිකුරාදා)";
  } else if (day === 6) {
    return "Saturday (සෙනසුරාදා)";
  } else if (day === 7) {
    return "Sunday (ඉරිදා)";
  } else if (day === 0) {
    return "Sunday (ඉරිදා)";
  }

  return "";
};

// const formatDate = (dateString) => {
//   if (!dateString) return "N/A";
//   const date = new Date(dateString);
//   return date.toLocaleDateString("en-US", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });
// };

export const scheduleDate = (startDate, endDate) => {
  const dayName = getDayFromDate(startDate);
  const monthName = getMonthNameFromDate(startDate);
  const dStartDate = new Date(startDate);
  const day = String(dStartDate.getDate()).padStart(2, "0");

  const d = `${monthName} ${day} | ${dayName}`;
  return d;
};

export const scheduleTime = (startDate, endDate) => {
  const dStartDate = new Date(startDate);
  const dEndDate = new Date(endDate);

  const startTime =
    dStartDate.getHours() +
    ":" +
    String(dStartDate.getMinutes()).padStart(2, "0");
  const endTime =
    dEndDate.getHours() + ":" + String(dEndDate.getMinutes()).padStart(2, "0");

  // 9:00 AM – 11:00 AM

  const d = `${startTime} - ${endTime}`;
  return d;
};

export const scheduleDateTime = (startDate, endDate) => {
  const dayName = getDayFromDate(startDate);
  const monthName = getMonthNameFromDate(startDate);
  const dStartDate = new Date(startDate);
  const dEndDate = new Date(endDate);
  const day = String(dStartDate.getDate()).padStart(2, "0");

  const startTime =
    dStartDate.getHours() +
    ":" +
    String(dStartDate.getMinutes()).padStart(2, "0");
  const endTime =
    dEndDate.getHours() + ":" + String(dEndDate.getMinutes()).padStart(2, "0");

  //     January 01 (ජනවාරි) | Thursday (බ්‍රහස්පතින්දා)
  // ⏰ 9:00 AM – 11:00 AM

  const d = `${monthName} ${day} | ${dayName} ⏰  ${startTime} - ${endTime}`;
  return d;
};

export const formatAmount = (amout, withCurrency = false) => {
  amout = Number(amout);
  if (amout && amout !== 0) {
    return (withCurrency ? "LKR " : "") + (amout ? amout.toFixed(2) : "");
  } else {
    return (withCurrency ? "LKR " : "") + "0.00";
  }
};

export const getTodayDate = (format = 2) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  if (format === 2) {
    return `${mm}/${dd}/${yyyy}`;
  }
  return `${yyyy}-${mm}-${dd}`;
};

export const getStatusBadge = (status) => {
  const statusNum = Number(status);
  if (statusNum === 1) {
    return (
      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
        Active
      </span>
    );
  } else {
    return (
      <span className="px-2 py-1 text-xs font-semibold rounded-full bg-gray-100 text-gray-800">
        Inactive
      </span>
    );
  }
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

export const isBunnyVideo = (url) => {
  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === "https:" &&
      parsed.hostname.startsWith("iframe.mediadelivery.net")
    );
  } catch {
    return false; // invalid URL
  }
};

export const isYoutubeVideo = (url) => {
  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === "https:" &&
      (parsed.hostname.startsWith("youtu.be") ||
        parsed.hostname.startsWith("youtube.com"))
    );
  } catch {
    return false; // invalid URL
  }
};

const secretKey = "62jdgf828nkewekndskh8";

export const encryptText = (text) => {
  return CryptoJS.AES.encrypt(text.toString(), secretKey).toString();
};

export const decryptText = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const storeTokens = async (accessToken, refreshToken) => {
  localStorage.setItem("token", accessToken);

  const encryptedRefreshToken = await encryptText(refreshToken);
  localStorage.setItem("refreshToken", encryptedRefreshToken);
};

export const checkUserHasAccess = (
  accessUserLevelIds,
  myEncryptedUserLevelId,
) => {
  if (myEncryptedUserLevelId && myEncryptedUserLevelId.length > 0) {
    const userLevelId = Number(decryptText(myEncryptedUserLevelId));
    return accessUserLevelIds.includes(userLevelId);
  } else {
    return false;
  }
};

export const getSeminarPaymentType = (type) => {
  if (type === 1) {
    return "Bank Transfer";
  } else if (type === 2) {
    return "Online";
  } else if (type === 6 || type === 7) {
    return "Assigned By Admin";
  } else {
    return "";
  }
}

export const extractYouTubeVideoId = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/.*[?&]v=([^&\n?#]+)/,
    /youtube\.com\/live\/([^&\n?#]+)/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) return match[1];
  }
  return null;
};

export const extractBunnyThumbnail = (url) => {
  if (!url) return null;
  // HLS stream URL: https://<pullzone>.b-cdn.net/<videoId>/playlist.m3u8
  if (url.includes("playlist.m3u8")) {
    return url.replace("playlist.m3u8", "thumbnail.jpg");
  }
  return null;
};

export const sideBarActiveBgColor = "bg-gradient-to-br from-black to-amber-500";
export const tableHeaderColor = "bg-gradient-to-br from-black to-amber-500";
